var I18n_fr = {
  languages_name: {
    fr: 'Français',
    eu: 'Basque',
    es: 'Espagnol',
    en: 'Anglais',
  },
  tuto: {
    next: 'SUIVANT',
    page1_title: 'Informations',
    page1_subtitle:
      "Soyez mieux informé sur l'état de la mer et la météo locale",
    page1_description:
      'Couleur du drapeau, météo locale, état de la mer: retrouvez toutes les informations pratiques des zones de baignade de la Communauté Pays Basque.',
    page2_title: 'Votre application',
    page2_subtitle:
      "Personnalisez l'application en sélectionnant vos plages favorites",
    page2_description:
      "Personnalisez l'application en sélectionnant vos plages favorites pour suivre les évolutions des conditions de vos zones de baignade.",
    page3_title: 'Merci à eux',
    page3_subtitle: "Ce projet a été cofinancé par l'Union Européenne",
    page3_description:
      "L'Europe s'engage en Nouvelle Aquitaine avec le Fonds Européen pour le Développement Régional.",
  },
  flag_explanations: {
    explanation_0: 'Plage non-surveillée',
    explanation_1: 'Baignade surveillée sans danger apparent',
    explanation_2: 'Baignade surveillée avec danger limité ou marqué',
    explanation_3: 'Baignade interdite',
    explanation_31: 'Baignade interdite',
    explanation_32: 'Baignade interdite\nMauvaises conditions météo',
    explanation_33:
      'Baignade interdite\nConditions de baignade dangereuses (houle, courant)',
      //TODO : A MODIFIER DANS LES AUTRES LANGUES !!!!!!
    explanation_34: 'Baignade interdite\nMéduses ou Physalies',
      //EO TODO
    explanation_35: 'Baignade interdite\nPollution (déchets flottants …)',
    explanation_36: 'Baignade interdite\nEvènementiel',
    explanation_37: 'Baignade interdite\nIntervention de sauvetage en cours',
    explanation_38: 'Baignade interdite\nOstreopsis dans la zone de bain',
    explanation_4:
      'Baignade interdite\nDégradation momentanée de la qualité de l’eau',
    explanation_5: 'Baignade non surveillée',
    //TODO : A AJOUTER DANS LES AUTRES LANGUES !!!!!!
    explanation_6: 'Vigie Océane',
    //EO TODO
    explanation_null: '',
    conform_quality: 'Qualité conforme',
    not_conform_quality: 'Qualité non conforme',
    no_quality: 'Qualité non renseignée',
  },
  //TODO : A AJOUTER DANS LES AUTRES LANGUES !!!!!!
  quality_explanations: {
    explanation_1: 'Qualité conforme',
    explanation_3: 'Qualité conforme',
    explanation_2: 'Qualité non conforme',
    explanation_4: 'Qualité non conforme',
    explanation_5: 'Qualité non conforme',
    explanation_0: 'Qualité non renseignée',
    explanation_51: 'Fortes pluies, orages',
    explanation_52: 'Incident technique – réseau',
    explanation_53: 'Dégradation venue du large',
    explanation_54: 'Panache du fleuve',
  },
  ostreopsis_explanations : {
    explanation_0: 'Ostreopsis - Aucun risque',
    explanation_1: 'Ostreopsis – vigilance faible',
    explanation_2: 'Ostreopsis – vigilance modérée',
    explanation_3: 'Ostreopsis – vigilance modérée',
    explanation_4: 'Ostreopsis – vigilance forte',
  },
  alertform: {
    header_title: 'Alerter',
    type: 'Type',
    localization: 'Localisation',
    description: 'Description',
    incomplete_desc: 'Description incomplète',
    incomplete_desc_text:
      'Veuillez définir au moins un type et une description (ou photo)...',
    thanks: 'Merci',
    classify: 'Classification',
    free_description: 'Description libre',
    your_info: 'Vos coordonnées',
    position: 'Position géographique',
    photo: 'Photo',
    alert_success_text:
      'Merci pour votre signalement - En cas de danger merci de prévenir les urgences en appelant le 18',
    pollution: 'Pollution',
    security: 'Sécurité/Risques',
    echouage: 'Echouage',
    other: 'Autres',
    sea: 'Mer',
    beach: 'Plage',
    dead_animal: 'Animal mort',
    difficulty_animal: 'Animal en difficulté',
    waste: 'Déchets',
    odour: 'Odeur',
    medusa: 'Méduses',
    wood: 'Bois',
    fishing_net: 'Filet',
    hydrocarbon: 'Hydrocarbure',
    turtle: 'Tortue',
    bird: 'Oiseau',
    mammal: 'Mammifère marin',
    theme1: "Rejet d'eau souillée",
    theme2: 'Animal échoué',
    theme3: 'Démangeaisons',
    theme4: 'Hydrocarbures',
    theme5: 'Méduses ou Physalies',
    theme6: 'Drapeaux',
    theme7: "Avis sur Kalilo",
    theme99: 'Autre',
    localiser: 'Localiser',
    send: 'Envoyer',
    validate: 'Valider la position',
    close: 'Fermer',
  },
  // EO TODO
  tabs: {
    beaches: 'Plages',
    alerts: 'Alertes',
    news: 'Infos',
    favorites: 'Favoris',
    more: 'Paramètres',
    app: 'Kalilo',
  },
  news: {
    header_title: 'Je m’informe',
    //title: "Bon à savoir",
    //subtitle: "L'agglomération met tout en oeuvre pour vous informer des bons gestes...",
    //show: "Afficher"
  },
  alerts: {
    header_title: 'Alertes',
    title: 'Alertes',
    subtitle:
      'La Communauté Pays Basque met tout en œuvre pour vous informer des événements sur le littoral.',
    tell_a_friend: 'PRÉVENIR',
  },
  beaches_list: {
    title: 'Explorer',
    favorites: 'Favoris',
    search_beach: 'Chercher une plage',
    beaches: 'plages',
    beach: 'plage',
  },
  beaches_filters: {
    page_title: 'Filtres',
    page_subtitle: 'Que souhaitez vous afficher ?',
    beaches_title: 'Plages',
    beaches_favorites: 'Mes plages favorites uniquement',
    services_title: 'Services',
    services_subtitle: 'Afficher uniquement les services suivants',
    show: 'Afficher',
    service_1: 'Handiplage',
    service_2: 'Parking',
    service_3: 'Activités nautiques',
    service_4: 'Club de loisir',
    service_5: 'Sanitaires Douches',
    service_6: 'Douches',
    service_8: 'Restauration',
    filter_result_1: 'plage concernée par vos critères',
    filter_result_2: ' plages concernées par vos critères',
  },
  beaches_search: {
    title: 'Recherche...',
    search: 'Chercher une plage',
  },
  beach_details: {
    tab_informations: 'INFORMATIONS',
    tab_previsions: 'MÉTÉO',
    tab_go: "S'Y RENDRE",
    oversight: 'Surveillance',
    phone: 'TÉLÉPHONE',
    more_info: 'EN SAVOIR PLUS',
    favorites: 'FAVORIS',
    pavillon_bleu: 'Label Pavillon Bleu',
    demarche_qualite: 'Certification qualité eau de baignade',
    updated_on: 'Mis à jour le',
    updated_today: 'Mis à jour à',
    updated_at_time: 'à',
  },
  beaches_favorites: {
    title: 'Favoris',
    beaches: 'plages',
    beach: 'plage',
    intro: 'Retrouvez ici la liste de vos plages favorites.',
    no_beach_title: "Vous n'avez pas encore de plage favorite !",
    no_beach_desc:
      'Ajoutez une ou plusieurs plages à vos favoris et recevez uniquement leurs informations.',
    add: 'Ajouter',
  },
  settings: {
    title: 'Paramètres',
    choose_language: 'Votre langue',
    language: 'Langue choisie',
    choose_notifications: 'Activer les notifications',
    notifications:
      'Activez les notifications pour recevoir instantanément les changements de conditions pouvant survenir sur vos plages favorites (couleur de drapeau, …)',
    informations: 'Informations',
    legal_notices: 'Mentions légales',
    credits: 'Crédits',
    about: 'À Propos',
    help: 'Aide',
  },
  about: {
    page_title: 'À Propos',
    description:
      'Kalilo est une application qui vous permet de vous tenir informé des conditions de baignade. Cependant, votre sécurité est avant tout liée à votre comportement : vous devez prioritairement vous fier aux informations qui sont transmises par les postes de secours. Si vous devez constater une différence entre la couleur d’un drapeau flottant sur une plage et le drapeau indiqué sur l’application, vous devez vous fier en priorité à la couleur du drapeau hissé sur la plage.',
  },
  legal_noticies: {
    page_title: 'Mentions légales',
    description: `
L’application Kalilo est éditée par la Communauté Pays Basque

Contact :
littoral@communaute-paysbasque.fr

Direction de la communication :
communication@communaute-paysbasque.fr
    `,
    description2: `Les données personnelles des internautes collectées sont exclusivement destinées à l'éditeur du site et traitées dans le respect des dispositions de la loi n°78-17 du 6 janvier 1978, dite Loi Informatique et Libertés. Le responsable du traitement des données est l'éditeur tel qu'identifié ci-dessus : aucune donnée personnelle n'est cédée ou communiquée à un tiers.`,
  },
  credits: {
    page_title: 'Crédits',
    source_title: 'Source des données',
    source_description: 'Voir la rubrique info',
    dev_title: 'Développement',
    design_ux_title: 'Design UX et Conception graphique UI :',
    design_title: 'Design de la marque',
    credits_title: 'Crédits Photos',
  },
  settings_language: {
    title: 'Langues',
    apply_button: 'Appliquer',
    question: 'Quelle langue souhaitez-vous appliquer?',
  },
  days_name: {
    1: 'Lundi',
    2: 'Mardi',
    3: 'Mercredi',
    4: 'Jeudi',
    5: 'Vendredi',
    6: 'Samedi',
    0: 'Dimanche',
  },
  days_subname: {
    0: "Aujourd'hui",
    1: 'Demain',
    2: 'Après demain',
  },
  creneau: {
    1: 'Matin',
    2: 'Midi',
    3: 'Soir',
  },
  weather: {
    swell: 'Houle',
    period: 'Période',
    direction: 'Direction',
    tides: 'Marées',
    hm: 'HAUTE MER',
    bm: 'BASSE MER',
    coeff: 'COEFFICIENT',
    wind: 'Vent',
    water_temp: 'T°eau',
    uv: 'UV',
  },
  location: {
    itinerary: 'ITINÉRAIRE',
    txiktxak: 'TRANSPORT',
  },
  map: {
    title: 'Hors saison',
    line_1: 'Restez informé sur l’état de la mer et la météo locale !',
    line_2:
      'Rappel : La baignade n’est pas surveillée, elle se pratique aux risques et périls de l’usager.',
  },
  map_pleine_saison: {
    title: 'Restez informé',
  },
  map_hors_saison: {
    title: 'Hors saison',
    line_1: 'Restez informé sur l’état de la mer et la météo locale !',
    line_2:
      'Rappel : La baignade n’est pas surveillée, elle se pratique aux risques et périls de l’usager.',
  },
  map_all_beaches_closed: {
    title: "Hors surveillance",
    line_1:
      "La baignade n’est pas surveillée actuellement, elle se pratique aux risques et périls de l’usager.",
  },
  map_switch: {
    flag: "Couleur des drapeaux",
    quality: "Qualité bactériologique de l’eau",
    ostreopsis: "Niveau de vigilance Ostreopsis",
  },
};

export default I18n_fr;
